import { environment } from '@env/environment';

const { apiUrl } = environment;

/**
 * ### **RouteEndpoint**
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición, en este caso las relacionadas a las rutas turísticas.
 */
export class RouteEndpoint {
  /** Endpoint que retorna la información de las rutas turísticas.*/
  static route = `${apiUrl}route/`;
  /** Endpoint que retorna la informacion de una ruta turística*/
  static routeDetail = `${apiUrl}route/{}/`;
}
